<template>
	<div>
		<a-modal id='operation1' width='50rem' v-model="visible" on-ok="handleOk1"
			v-dragModal :dialog-style="{ top:'15vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 48rem;margin: 1rem 1rem 0 1rem;text-align: center;">
					操作日志
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 48rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 0.5rem;">
					<div style="display: flex;justify-content: space-between;">
						<a-form-model ref='form' :model="form"  layout='inline' hideRequiredMark>
									<a-form-model-item label='操作日期' >
										<a-date-picker placeholder='' v-model='params.createtime' @change='fanhand'/>
									</a-form-model-item>
									
						</a-form-model>
						<div style="font-size: .8rem;color: #000;margin-top: .5rem;">操作人員：{{items.name}} </div>
					</div>
					<div style="max-height: 20rem;overflow-y: auto;">
						<a-table style="width:100%;min-height: 15rem;" :columns="columns" :data-source="columnsData" id='fromtable'
									:rowKey='(record, index) => index' 
									:pagination="false"
									:bordered="true">
									<div slot='status' slot-scope="record" style="white-space: nowrap;">
										<div v-if='record.status == 2' style="color: #ee5253">暫停</div>
										<div v-if='record.status == 1' style="color: #3bc7a1">使用中</div>
									</div>
									<div slot='email' slot-scope="record" style="white-space: nowrap;">{{record.email}}</div>
						</a-table>
					</div>
					<div class="paginationView">
						<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
						<div style="margin-left:auto;">
							<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
								:pageSize="params.perPage" />
						</div>
						<div class="pageTzView">
							<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
							<span @click="tzEvent">跳轉</span>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['items'],
		data() {
			return {
				tzPageNum: '',
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					position: '',
					"employee_number": "",
					"name_en": "",
					"email": "",
					status: '',
				},
				columns: [
					{
						title: '操作模塊',
						dataIndex: 'module',
						align: 'center',
						width: '25%'
					},
					{
						title: '操作權限',
						dataIndex: 'permissions',
						align: 'center',
						width: '25%',
						// scopedSlots: {
						// 	customRender: 'email'
						// }
					},
					{
						title: '操作信息',
						dataIndex: 'ip',
						align: 'center',
						width: '25%',
					},
					{
						title: '操作時間',
						dataIndex: 'handletime',
						align: 'center',
						width: '25%',
					}
				],
				columnsData: [],
				domainlist:[],
				visible: true,
				rules: {
					email:[{required:true,message:' ',trigger:'blur'}],
					position:[{required:true,message:' ',trigger:'change'}],
					system_type:[{required:true,message:' ',trigger:'change'}],
					name:[{required:true,message:' ',trigger:'blur'}],
				},
				form: {
					"email":"",
					 "position":"",
					 "status":1,
					 name:'',
				},
			}
		},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			// if(this.items){
			// 	this.handz()
			// }
			
			// this.getdata()
			this.messLoad();
		},
		methods: {
			fanhand(val) {
				this.params.createtime = this.params.createtime ? App.oDate.secsTime3(this.params.createtime._d) : '';
				this.messLoad();
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			messLoad() {
				console.log(this.items)
				this.params['adminid'] = this.items['adminid']
				this.$ajax({
					method: 'post',
					url: this.$api.getAdminHandleLogsWithAdminid,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.handlelogs
						
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			emailfn() {
				if (this.form.email) {
					var t = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
					if (!(t.test(this.form.email))) {
						this.form.email = ''
						this.$message.warning('請輸入正確的電郵地址')
					}
				}
			},
			getdata() {
				this.$ajax({
				method: 'post',
					url: this.$api.getParamList,
					data: {
						 "type":"position"
					}
				}).then(res => {
					if (res.data) {
						this.domainlist = res.data.result
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}})
			},
			handz(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.newAdminUser,
					data:this.form
				}).then(res => {
					if (res.data) {
						this.form = res.data
						// App.oTool.successT();
						console.log(this.form)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				// this.handz()
			},
			//下单
			handbect(ruleForm) {
				 this.$refs[ruleForm].validate(valid => {
				        if (valid) {
							this.form.token = this.$store.state.token;
							this.$ajax({
								method: 'post',
								url: this.$api.newAdminUser,
								data: this.form
							}).then(res => {
								if (res.data.qmiscode === 1000) {
									App.oTool.successT();
									this.$emit('child', 1)
								} else {
									App.oTool.warningT(res.data.qmismsg);
								}
							})
				        } else {
				          console.log('error submit!!');
				          return false;
				        }
				      });
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	/* 分頁樣式 */
	#operation1 .paginationView {
	    padding-top: 1rem;
	    display: flex;
	    align-items: center;
	    width: 100%;
	    color: #666666;
		/* height:calc(100vh - 142px); */
	}
	
	#operation1 .ant-pagination-item {
	    background-color: #fff;
	    border-color: #bfbfbf;
	    color: #999999;
	    margin-right: 1rem;
	}
	
	#operation1 .ant-pagination-prev {
	    margin-right: 1rem;
	}
	
	#operation1 .ant-pagination-item a {
	    color: inherit;
	}
	
	#operation1 .ant-pagination-item-active {
	    background-color: #f3f3f3;
	    border-color: #d8d8d8;
	    color: #000;
	}
	
	#operation1 .ant-pagination-prev .ant-pagination-item-link,
	#operation1 .ant-pagination-next .ant-pagination-item-link {
	    background-color: #fff;
	    color: #666666;
	    border: 1px solid #bfbfbf;
	}
	
	#operation1 .ant-pagination-disabled a,
	#operation1 .ant-pagination-disabled:hover a,
	#operation1 .ant-pagination-disabled:focus a,
	#operation1 .ant-pagination-disabled .ant-pagination-item-link,
	#operation1 .ant-pagination-disabled:hover .ant-pagination-item-link,
	#operation1 .ant-pagination-disabled:focus .ant-pagination-item-link {
	    background-color: #d8d8d8!important;
	    color: #fff!important;
	}
	
	#operation1 .pageTzView {
	    display: flex;
	    align-items: center;
	    margin-left: 0.7rem;
	}
	
	#operation1 .pageTzView input {
	    width: 2.6rem;
	    height: 1.67rem;
	    border: 1px solid #bfbfbf;
	    outline: unset;
	    margin-right: 0.25rem;
	    border-radius: 4px;
	    text-align: center;
	}
	
	#operation1 .pageTzView span {
	    background-color: #d8d8d8;
	    border-radius: 4px;
	    height: 1.67rem;
	    color: #666666;
	    padding: 0 0.625rem;
	    line-height: 1.67rem;
	}
	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#operation1 {
		.ant-table-thead > tr > th, .ant-table-tbody > tr > td{
			    padding: 8px;
		}
		.ant-form-explain{
			display: none;
		}

		.ant-form-item, .ant-form-item-control{
			width: 100%;
		}
		
		.ant-form-item-control-wrapper{
			// width: 90% !important;
			.ant-form-item-control{
				width: 100%;
			}
		}

		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}


		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: .5rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.ant-modal-body {
			background-color: #e5e5e5 !important;
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
</style>
